export const RpeCategory = {
  AVAILABILITY: 'availability',
  SESSION_RPE: 'session_rpe',
  WELLNESS: 'wellness',
} as const;

export type RpeCategory = (typeof RpeCategory)[keyof typeof RpeCategory];
